import { axiosInstance as axios } from '../lib/axios';
import { pickClient } from '../lib/apimRoutes';
import Config from '../config/environments';
import { POST_PROPERTYTYPES, LIST_PROPERTYTYPES } from '../actionTypes/propertytypes';
import { viewsModelToModels } from '../mapper/propertytypes';
import updateState from './common/common';

export const getDataPropertyTypes = () => async (dispatch) => {
  const base = {
    type: LIST_PROPERTYTYPES,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.PROPERTYTYPES.URL}`;
  const client = pickClient('GET', url);

  client.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const getDataPropertyTypesWithoutPagination = () => async (dispatch) => {
  const base = {
    type: LIST_PROPERTYTYPES,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.PROPERTYTYPES.URL}?page=1&quantity=100`;
  const client = pickClient('GET', url);

  client.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const postDataPropertyTypes = (data) => async (dispatch) => {
  const base = {
    type: POST_PROPERTYTYPES,
    payload: {},
    state: true,
    success: true,
  };

  const url = Config.PROPERTYTYPES.URL;

  axios.post(url, data).then((response) => {
    base.payload = updateState(response);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const putDataPropertyTypes = (data) => async (dispatch) => {
  const base = {
    type: POST_PROPERTYTYPES,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.PROPERTYTYPES.URL}/${data.uuid}`;

  axios.put(url, data).then((response) => {
    base.payload = updateState(response);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};
